import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormInstance, FormRule } from 'antd';
import { Form, Input, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useGetManyClients } from 'api/clients/use-get-many-clients';
import { useDebounce } from 'shared/hooks/use-debounce';
import { InputWithSearchSimilarModal } from '../input-with-search-similar-modal';

interface IInputWithSearchResultsProps {
  name: string;
  label?: string;
  placeholder: string;
  validationRule: FormRule[];
  form: FormInstance;
  withFindingSimilar?: boolean;
}

export const InputWithSearchSimilar: React.FC<IInputWithSearchResultsProps> = (props) => {
  const { name, label, placeholder, validationRule, form, withFindingSimilar = false } = props;
  const { t } = useTranslation('client');

  const search = Form.useWatch(name, form);
  const searchTerm = useDebounce<string>(search, 1000);

  const { data: clients, isLoading } = useGetManyClients({
    search: searchTerm,
    isHints: true,
    enabled: withFindingSimilar,
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => setIsModalVisible(true);
  const handleClose = () => setIsModalVisible(false);

  const spinnerIcon = <LoadingOutlined style={{ fontSize: 16 }} spin />;

  const suffixContent = () => {
    if (!form.getFieldValue(name)) return <span />;
    if (isLoading) {
      return <Spin indicator={spinnerIcon} />;
    } else if (clients && clients.data?.length > 0) {
      return (
        <Typography.Text type='danger' style={{ cursor: 'pointer' }} onClick={showModal}>
          {t('similar_clients')} ({clients?.data?.length})
        </Typography.Text>
      );
    }
    return <span />;
  };

  const suffix = withFindingSimilar ? suffixContent() : null;
  return (
    <>
      <Form.Item name={name} label={label} rules={validationRule}>
        <Input placeholder={placeholder} suffix={suffix} />
      </Form.Item>
      <InputWithSearchSimilarModal
        isModalVisible={isModalVisible}
        handleClose={handleClose}
        clients={clients?.data || []}
      />
    </>
  );
};
